<template>
  <div
    ref="stickyElement"
    class="advance-anchor-point"
    :class="{ 'is-isSticky': isSticky }"
  >
    <div class="anchor-point-list">
      <div
        v-for="(anchor, index) of anchroList"
        :key="index"
        class="anchor-point-list-item"
        :class="{'is-active': curIndex === index}"
        @click.stop="handleClickItem(anchor, index)"
      >
        {{ anchor.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      curIndex: 0,
      isSticky: false
    }
  },
  computed: {
    anchroList () {
      return this.$attrs.list || []
    }
  },
  mounted () {
    // window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleClickItem (item, idx) {
      this.curIndex = idx
      const element = document.getElementById(item.linkId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    // 监听滚动 吸顶动作
    handleScroll () {
      // const stickyElement = this.$refs.stickyElement
      // const offsetTop = stickyElement.offsetTop
      // this.isSticky = window.scrollY >= offsetTop
    }
  },
  beforeDestroy () {
    // window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="stylus" scoped>
.advance-anchor-point {
  position: relative;
  overflow: hidden;
  box-shadow: 0px 8px 8px 0px #CED6EC24;
  .anchor-point-list {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    .anchor-point-list-item {
      position: relative;
      color: #2F4673;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      padding: 0;
      margin: 0 16px;
      height: 66px;
      line-height: 66px;
      cursor: pointer;
      &:nth-child(1) {
        margin-left: 0
      }
      &:last-child {
        margin-right: 0
      }
    }
    .anchor-point-list-item.is-active {
      color: #155eff;
      &::after {
        display: block;
        content: '';
        height: 2px;
        background-color: #155eff;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
      }
    }
  }
}
// .is-isSticky {
//   position: fixed;
//   width: 100%;
//   left: 0;
//   top: 0;
//   transition: top .2s ease;
//   z-index: 100;
//   background: var(--bg_5)
// }
</style>
